import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { dateToString } from 'src/app/common/date-utils';
import { CargaCumplimientoRepository } from 'src/app/domain/service/cumplimiento/carga-cumplimiento-repository';
import { CargaCumplimiento, CargaCumplimientoFiltro } from 'src/app/domain/model/cumplimiento/carga-cumplimiento';

/**
 * Adaptador HTTP: HttpCargaCumplimientoRepository
 *
 * Implementa el puerto CargaCumplimientoRepository para comunicación HTTP con servicios-ms.
 *
 * Backend: 580-girop_servicios-ms (puerto 8080)
 * Endpoint: GET /api/cumplimiento/carga-masiva/resultado
 *
 * @legacy AdminCumplimientoHandler.consultaCargaCumplimiento()
 * @author Sura - Migración GWT a Angular
 */
@Injectable({ providedIn: 'root' })
export class HttpCargaCumplimientoRepository extends CargaCumplimientoRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/cumplimiento/carga-masiva/resultado`;

  override async consultarResultado(filtro: CargaCumplimientoFiltro): Promise<CargaCumplimiento[]> {
    let params = new HttpParams()
      .set('fechaInicial', dateToString(filtro.fechaInicial))
      .set('fechaFinal', dateToString(filtro.fechaFinal));

    // Spring acepta múltiples valores para el mismo parámetro como lista
    filtro.estados.forEach(estado => {
      params = params.append('estados', estado);
    });

    return firstValueFrom(
      this.http.get<CargaCumplimiento[]>(this.baseUrl, { params })
    );
  }
}
